import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import type { FormControlValueTypes, FormState } from 'ngrx-forms';
import { SingleFieldStepViewModel } from '@innogy/shared/forms';
import type { RenderingField } from '@sitecore-jss/sitecore-jss-angular';
import type { SingleFieldExplanationContent } from '@legacy/common-ui-utility-components';
import { AsyncPipe } from '@angular/common';
import {
  ErrorCardComponent,
  MoreInfoButtonComponent,
} from '@legacy/common-ui-utility-components';
import { NumberComponent, InputErrorComponent } from '@innogy/common-ui/forms';
import { IsInvalidPipe } from '@innogy/utils-deprecated';

import type { SingleFieldQuestionContent } from '../../interfaces';
import { ProgressiveFormStepBaseComponent } from '../progressive-form-step.base.component';
import { ProgressiveFormService } from '../../progressive-form.service';
import { ProgressiveFormStepWrapperComponent } from '../../progressive-form-step-wrapper/progressive-form-step-wrapper.component';
import { ProgressiveFormBodyDirective } from '../../progressive-form-body.directive';
import { ProgressiveFormSummaryDirective } from '../../progressive-form-summary.directive';

@Component({
  selector:
    'wl-progressive-step-single-number-question[progressiveFormSelectorKey][content]',
  templateUrl: './progressive-step-single-number-question.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    ProgressiveFormStepWrapperComponent,
    ProgressiveFormBodyDirective,
    ErrorCardComponent,
    NumberComponent,
    InputErrorComponent,
    MoreInfoButtonComponent,
    ProgressiveFormSummaryDirective,
    AsyncPipe,
    IsInvalidPipe,
  ],
})
export class ProgressiveStepSingleNumberQuestionComponent<
  TFormFieldType extends FormControlValueTypes,
> extends ProgressiveFormStepBaseComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() override progressiveFormSelectorKey!: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() override rendering: InnogyComponentRendering | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() override content!: SingleFieldQuestionContent & {
    numberInput?: {
      placeholder?: RenderingField;
      isIntError?: RenderingField;
    };
  };
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() override formStep?: SingleFieldStepViewModel<TFormFieldType>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isReadonly = false;
  @Output()
  override giveMoreInfo: EventEmitter<SingleFieldExplanationContent> =
    new EventEmitter<SingleFieldExplanationContent>();

  get numberFormControl() {
    return this.formStep?.formState.controls.field as FormState<
      number | undefined
    >;
  }

  constructor(
    override readonly progressiveFormService: ProgressiveFormService
  ) {
    super(progressiveFormService);
  }
}
